import * as React from 'react';
import * as ReactTooltip from 'react-tooltip';
import './VerseListItem.css';

export interface BaseListItemProps {
    onWordClick: (verseIndex: number, sourceIndex: number, wordIndex: number, partIndex: number, text: string) => void;
}

export default abstract class BaseListItem<P extends BaseListItemProps> extends React.Component<P> {

    constructor(props: P) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    public componentDidMount(): void {
        ReactTooltip.rebuild();
    }

    public componentDidUpdate(): void {
        ReactTooltip.rebuild();
    }

    public render(): React.ReactNode {
        return <div onClick={this.onClick}>{this.renderContent()}</div>;
    }

    protected abstract renderContent(): React.ReactNode;

    private onClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void {
        const target = event.target as HTMLElement;
        if (!target.nodeName.match(/span/i)) {
            return;
        }

        const verseIndex = Number(target.dataset.verseIndex);
        const sourceIndex = Number(target.dataset.sourceIndex);
        const wordIndex = Number(target.dataset.wordIndex);
        const partIndex = Number(target.dataset.partIndex);
        if (isNaN(verseIndex) || isNaN(sourceIndex) || isNaN(wordIndex) || isNaN(partIndex)) {
            return;
        }

        const text = target.innerText;
        this.props.onWordClick(verseIndex, sourceIndex, wordIndex, partIndex, text);
    }
}
